import { Environment } from 'Common/environment/types'
import { fetchGet } from 'Common/utils/query/request'

export const getPublishingHouses = (environment: Environment, accessToken: string) =>
    fetchGet(`${environment.endpoints.metadata}/v1/metadata?filter=publishingHouses`, {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': 'sv-SE',
        Authorization: `Bearer ${accessToken}`,
        cache: 'force-cache',
    })
